import { render, staticRenderFns } from "./TestFormula.vue?vue&type=template&id=00686f71&scoped=true"
import script from "./TestFormula.vue?vue&type=script&lang=js"
export * from "./TestFormula.vue?vue&type=script&lang=js"
import style0 from "./TestFormula.vue?vue&type=style&index=0&id=00686f71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00686f71",
  null
  
)

export default component.exports